module.exports = __webpack_public_path__ + "img/loader.e700a73b.png";